import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const params = new URLSearchParams(location.search);
    const next = params.get("next") || "/my-rituals";

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(res.data.onboarded ? next : "/join?step=onboard", {
          replace: true,
          state: { user: res.data },
        });
      } catch {
        setError(true);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory">
      <div className="text-center" data-testid="auth-callback-status">
        {error ? (
          <div>
            <p className="font-serif text-2xl text-forest mb-2">Something interrupted your sign in</p>
            <a href="/login" className="text-forest underline underline-offset-4">Try again</a>
          </div>
        ) : (
          <p className="font-serif text-2xl text-forest animate-pulse">Welcoming you in…</p>
        )}
      </div>
    </div>
  );
}
